/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceLocation
 */
export interface ServiceLocation {
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    zip_code: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceLocation
     */
    county: string;
}

/**
 * Check if a given object implements the ServiceLocation interface.
 */
export function instanceOfServiceLocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "zip_code" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "county" in value;

    return isInstance;
}

export function ServiceLocationFromJSON(json: any): ServiceLocation {
    return ServiceLocationFromJSONTyped(json, false);
}

export function ServiceLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'street': json['street'],
        'zip_code': json['zip_code'],
        'city': json['city'],
        'state': json['state'],
        'county': json['county'],
    };
}

export function ServiceLocationToJSON(value?: ServiceLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'name': value.name,
        'phone': value.phone,
        'street': value.street,
        'zip_code': value.zip_code,
        'city': value.city,
        'state': value.state,
        'county': value.county,
    };
}

